import { PageHeader } from '../components/shared';
import { CampTable } from '../components/camp/camp-table';

export const Camp = () => {
  return (
    <div>
      <PageHeader title='Campamentos' />
      <CampTable />
    </div>
  );
};
